import { useFetcher } from '@remix-run/react';
import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from 'react';
import { DEFAULT_THEME, Theme } from '../utils/theme-utils';

type ThemeContextValue = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
};

const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export function ThemeProviderServerHydrated({
  children,
  initialTheme,
}: {
  children: ReactNode;
  initialTheme: Theme | null;
}) {
  const [theme, setTheme] = useState<Theme | null>(initialTheme);
  const fetcher = useFetcher();

  useEffect(() => {
    // Theme is not set yet. Use the system theme.
    if (theme === null) {
      // const prefersDark = window.matchMedia(
      //   '(prefers-color-scheme: dark)',
      // ).matches;
      // setTheme(prefersDark ? 'dark' : 'light');
      setTheme('dark');
      return;
    }

    // Theme is already set. Submit the theme to the server.
    fetcher.submit({ theme: theme }, { method: 'post', action: '/theme' });
  }, [theme]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <ThemeContext.Provider value={{ theme: theme ?? DEFAULT_THEME, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}
